var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var isShareableWithTeams = function (user, recipientsOrBasket) {
    if (recipientsOrBasket === void 0) { recipientsOrBasket = []; }
    // cover legacy until native will update to pass the recipients array without the wrapper
    var recipients = recipientsOrBasket;
    if (!Array.isArray(recipientsOrBasket)) {
        recipients = recipientsOrBasket.recipients;
    }
    var ids = shareableWithTeamsIds(user, recipients);
    return ids.length > 0;
};
export var shareableWithTeamsIds = function (user, recipientsOrBasket) {
    if (recipientsOrBasket === void 0) { recipientsOrBasket = []; }
    var recipients = recipientsOrBasket;
    if (!Array.isArray(recipientsOrBasket)) {
        recipients = recipientsOrBasket.recipients;
    }
    var _a = user.teamIds, userTeams = _a === void 0 ? [] : _a;
    var recipientsTeams = recipients
        .map(function (recipient) { return recipient.teams; })
        .filter(function (teams) { return teams; })
        .reduce(function (carry, teams) {
        // The native user -> teams already come back as an array of teamId's
        // from the user picker so there is no need to map over and get the uuid
        if (teams && teams.results) {
            return __spreadArrays(carry, teams.results.map(function (_a) {
                var uuid = _a.uuid;
                return uuid;
            }));
        }
        return __spreadArrays(carry, teams);
    }, []);
    var teamIds = [];
    recipientsTeams.map(function (teamId) { return teamIds.push(teamId); });
    userTeams.map(function (teamId) { return teamIds.push(teamId); });
    return teamIds;
};
